<button
  mat-button
  [disabled]="outOfStock"
  class="transparent-button gift-button"
  (click)="openBottomSheet()"
>
  <img
    [ngStyle]="{ filter: outOfStock ? 'opacity(0.5)' : 'none' }"
    src="/assets/images/icons/gift.svg"
    alt=""
  />
  <span>Buy As Gift</span>
</button>
